<template>
    <div class="header">
        <div class="navigation">
            <!-- nav-left -->
            <div class="navigation__left">
                <div class="back-button" v-if="isPage(['register'])" @click="$router.go(-1)">
                    <img :src="leftArrowImage" alt="Back button">
                    <p v-if="isDesktop">{{$t('TOP_NAVIGATION_BACK_BUTTON')}}</p>
                </div>
                <div v-if="isDesktop && !isPage(['register'])" class="navigation__landing-buttons">
                    <div :key="button.label" v-for="button in filteredButtons">
                        <nav-button :button="button" class="navigation__landing-button"/>
                    </div>
                </div>
                <help-button v-if="!isPage(['register'])" class="navigation__help"></help-button>
            </div>

            <!-- nav-center -->
            <div class="navigation__center">
                <router-link :to="{ name: 'home'}">
                    <img class="navigation__desktop-logo"
                        :src="freddiesLogo"
                        alt="Freddie's Flowers Desktop Logo"/>
                </router-link>
            </div>

            <!-- nav-right -->
            <div class="navigation__right" :class="{ 'nav-right': showSignIn }">
                <!-- <router-link v-if="isFlowerBondHolder" target="_blank" :to="{ name: 'flowerbond'}">
                    <div class="bondHolderButton">
                        <img class="bondHolderButton__icon" :src="flowerBondIcon" alt="Flower Bond Holder"/>
                        <p class="bondHolderButton__text" v-text="$t('NAV_BOND_HOLDER')"></p>
                    </div>
                </router-link> -->
                <login-link v-if="showSignIn"></login-link>
                <button v-if="showSignUp" class="btn--primary-black sign-up-btn"
                    @click="$router.push({ name: 'register' })">
                    {{ $t('SEND_ME_FLOWERS')}}
                </button>
                <div class="after-login-container">
                    <order-summary-button v-if="showBasket"/>
                    <my-account v-if="showMyAccount"></my-account>
                </div>
                <!-- <div class="checkout-help-button" @click="go(checkoutHelpButton.route)" v-if="isPage(['register'])">
                    <img v-if="!isDesktop" src="@/assets/images/pages/checkout/hekpImage.png" alt="Help button">
                    <nav-button :customStyles="customStyles" :button="checkoutHelpButton" class="navigation__landing-button"/>
                </div> -->
            </div>
        </div>
        <div class="divider-paper--marker divider--not-fixed"></div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import LoginLink from '@/components/structure/navigation/navigation/LogInLink';
import HelpButton from '@/components/structure/navigation/navigation/HelpButton';
import NavButton from '@/components/structure/navigation/navigation/NavButton';
import OrderSummaryButton from '@/components/structure/navigation/navigation/OrderSummaryButton';
import MyAccount from '@/components/structure/navigation/navigation/MyAccount';
import countryUtils from '@/resources/countryUtils.json';

export default {
    name: 'TopNavigation',
    data() {
        return {
            countryUtils: countryUtils.filter(item => item.locale.toLowerCase() === process.env.VUE_APP_DATE_LOCALE.toLowerCase())[0],
            flowerBondIcon: require('@/assets/images/decoration/icon-bondholder-nav.svg'),
            window: {
                width: 0,
                mobileBreakpoint: 767,
                desktopLowerBreakpoint: 1024,
            },
            isXmas: true,
        };
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    computed: {
        ...mapGetters({
            buttons: 'nav/getButtons',
            isUserLoggedIn: 'auth/isUserLoggedIn',
            isFlowerBondHolder: 'account/getFlowerBondStatus',
            hasUserFetched: 'account/getUserId',
            hasSubscriptionFetched: 'subscription/subscriptionsHaveFetched',
            hasActiveSubscription: 'subscription/hasActiveSubscription',
            themes: 'account/getThemes',
        }),
        filteredButtons() {
            const status = (this.isUserLoggedIn ? 'loggedIn' : 'loggedOut');
            return this.buttons.filter(button => this.hasNoActiveSubscription ? button[status] && button.label.toLowerCase() !== 'shop' : button[status]);
        },
        checkoutHelpButton() {
            return this.buttons.filter(button => button.label.toLowerCase() === 'help')[0];
        },
        isDesktop() {
            const isDesktop = this.window.width >= this.window.desktopLowerBreakpoint;
            this.$store.commit('account/setIsDesktop', isDesktop);
            return isDesktop;
        },
        leftArrowImage() {
            return this.isDesktop ? require('@/assets/images/decoration/arrow-left.svg') : require('@/assets/images/decoration/arrow-left-large.svg');
        },
        isMobile() {
            let isMobile = this.window.width <= this.window.mobileBreakpoint;
            this.$store.commit('account/setIsMobile', isMobile);
            return isMobile;
        },
        hasNoActiveSubscription() {
            return this.hasUserFetched && this.hasSubscriptionFetched && !this.hasActiveSubscription;
        },
        showSignIn() {
            return !this.isPage(['account-confirmation', 'account', 'faq', 'register', 'login']) ||
            (this.isUserLoggedIn && this.hasUserFetched && this.hasSubscriptionFetched && !this.hasActiveSubscription);
        },
        showSignUp() {
            return this.isDesktop && !this.isUserLoggedIn && !this.isPage(['register']);
        },
        showBasket() {
            return this.isUserLoggedIn && this.hasActiveSubscription;
        },
        showMyAccount() {
            return !this.isMobile && this.isUserLoggedIn && this.hasActiveSubscription;
        },
        customStyles() {
            return !this.isDesktop ? { fontSize: '12px', lineHeight: '16px' } : {};
        },
        freddiesLogo() {
            return this.themes?.logo || require('@/assets/images/logos/freddies_flowers_stacked.svg');
        },
    },
    methods: {
        isPage(pageArr) {
            if (this.$route.name.includes('account-confirmation')) return true;
            const pageRoot = this.$route.name.split('.')[0];
            return pageArr.find(page => pageRoot === page);
        },
        go(route) {
            route === 'faq.categories' ? window.location.href = this.countryUtils.zendesk_hc_url : this.$router.push({ name: route });
        },
        handleResize() {
            this.window.width = window.innerWidth;
        },
    },
    components: {
        LoginLink,
        HelpButton,
        OrderSummaryButton,
        NavButton,
        MyAccount,
    },
};
</script>

<style lang="scss" >
    .header {
        position: fixed;
        width: 100vw;
        z-index: 99;
    }

    .navigation {
        display: flex;
        justify-content: space-between;
        align-content: center;
        padding: 0 24px;
        height: 70px;
        z-index: 99;
        background-color: #FFFFFF;

        &__left {
            flex: 2;
        }

        &__center {
            flex: 1;
            padding-bottom: 8px;
            justify-content: center;
        }

        &__right {
            flex: 2;
            justify-content: flex-end;
        }

        &__left, &__center, &__right {
            display: flex;
            align-items: center
        }

        &__landing-button {
            cursor: pointer;
            text-align: center;
            img {
                margin: 0 auto;
                height: 45px;
            }
            h5 {
                font-size: 10px;
                margin: 0;
            }
        }

        &__help {
            display: block;
        }

        &__desktop-logo {
            cursor: pointer;
            display: block;
            max-width: 138px;
            height: 50px;
        }

        &__mobile-logo-container {
            width: 100%;
        }

        &__mobile-logo {
            display: block;
            width: 100%;
            max-width: 380px;
        }
        &__title {
            font-size: 1.25rem;
            line-height: 1;
            font-family: FreddiesFlowersTitle;
            padding-top: 4px;
        }
        &__title > span {
            font-size: 0.5em;
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
            display: block;
            text-transform: uppercase;
        }
    }

    .after-login-container {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0px 0px 8px 0px;
    }

    @media (min-width: 768px) {
        .navigation {

            &__left {
            }

            &__right {
                margin-right: -16px;
            }

            &__landing-buttons {
                display: none;
            }
        }

        .after-login-container {
            margin-bottom: 0px;
        }
    }
    @media (min-width: 1024px) {
        .navigation {
            height: 94px;
            padding: 16px 0px;

            &__left {
            }

            &__center {
            }

            &__right {
                margin-right: 0px;
                padding-right: 8px;
                padding-bottom: 0;
                > * {
                    margin: 0 8px;
                }
            }

            &__landing-buttons {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                margin-left: 40px;
            }

            &__landing-button {
                margin-right: 40px;
            }

            &__help {
                display: none;
            }

            &__desktop-logo {
                cursor: pointer;
                display: block;
                max-width: 158px;
                height: 57px;
            }

            &__mobile-logo-container {
                width: auto;
            }

            &__mobile-logo {
                display: none;
            }
        }
    }

    .sign-up-btn {
        padding-left: 0px;
        padding-right: 0px;
        height: 40px;
        width: 182px;
        border-radius: 4px
    }

    .sign-up-btn:hover {
        background-color: #C2D1A7;
    }

    .back-button {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 5px;
        @media (min-width: 1024px) {
            margin-left: 16px;
        }
        &:hover {
            cursor: pointer;
        }
        & img {
            width: 24px;
        }
        & p {
            line-height: 24px;
            font-size: 20px;
            margin: 2px 0 0 0;
        }
    }

    .checkout-help-button {
        display: flex;
        align-items: center;
        justify-content: space-around;
        flex-direction: column;
        font-size: 12px;
        & img {
            width: 36px;
            height: 36px;
        }
    }

    .nav-right {
        margin-right: 0px;
    }

</style>
